module.exports = __webpack_public_path__ + "img/banner_c.d587c57a.jpg";